<div class="bar-container" [@fadeInOut]>
    <app-horizontal-bar *ngFor="let item of graph.data;trackBy : trackByFn"
        [maxValue]="maxValue" [item]="item" (click)="barClick(item.title)"
        [selected]="selectedItem === item.title" [withGestures]="withGestures">
    </app-horizontal-bar>
</div>